export default __webpack_public_path__ + "static/media/_1.74c8b521.jpg";